import React, { useState } from "react";
import logo from "../images/mb-m-500-white.png";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "About", id: "about" },
    { label: "Why Metabetta?", id: "why" },
    { label: "Services", id: "services" },
    { label: "AI Architecture", id: "metabettaai" },
    { label: "Business Solutions", id: "business" },
  ];

  return (
    <header className="absolute top-0 left-0 right-0 z-30 pt-8 max-w-screen-xl mx-auto flex items-center justify-between px-6">
      {/* Logo */}
      <a href="/" className="flex items-center gap-2 text-white font-black text-2xl no-underline">
        <img src={logo} alt="Metabetta logo" className="w-10" />
        <span>Metabetta</span>
      </a>

      {/* Desktop nav */}
      <nav className="hidden lg:flex items-center gap-6">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={"/#" + link.id}
            className="text-white text-sm font-semibold tracking-wide border-b-2 border-transparent hover:border-primary-500 hover:text-primary-100 transition pb-1"
          >
            {link.label}
          </a>
        ))}
        <a
          href="/#contact"
          className="ml-4 px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-700 transition"
        >
          Contact Us
        </a>
      </nav>

      {/* Mobile toggle */}
      <button
        className="lg:hidden text-white focus:outline-none"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle navigation menu"
      >
        {mobileOpen ? (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden absolute top-20 left-4 right-4 bg-white rounded-lg shadow-lg p-8 z-50">
          <nav className="flex flex-col items-center gap-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={"/#" + link.id}
                className="text-gray-900 text-lg font-semibold hover:text-primary-500 transition"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/#contact"
              className="mt-4 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-700 transition"
              onClick={() => setMobileOpen(false)}
            >
              Contact Us
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
